import styled from '@react-pdf/styled-components';
import { ContainerRadius } from '../styles';

export const Container = styled.View`
  width: 100%;
  height: 210px;
  margin: 20px 0 20px 0;
  display: flex;
  flex-direction: row;
`;

export const LeftContainer = styled(ContainerRadius)`
  width: 200px;
  height: 100%;
  margin-right: 15px;
  padding: 10px;
  display: flex;
`;

export const ItemCard = styled.View`
  width:100%;
  height: auto;
  flex:1;  
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
  overflow:hidden;
`;

export const RightContainer = styled(ContainerRadius)`
  width:350px;
  height: 100%;
  padding: 10px;
`;
